
import { SymbolData } from '../types';

export const godsData: SymbolData[] = [
  {
    id: 'god-zhifu',
    char: '符',
    pinyin: 'Zhí Fú',
    summary: '直符：贵',
    tags: ['最有权', '最有钱', '最有名'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002211749.png',
    story: '在金碧辉煌的议事厅中，最高领导者（值符）身着华丽的袍服，正坐在象征主位的中央。他处理着一份涉及重大决策的重要文件，展现出正直和公正的品格。他手中拿着一枚贵重的印章，这枚印章不仅象征着权威和财富，也代表着他作为上级的尊荣。整个场景充满了高贵和威严，一切都围绕着核心和关键展开。',
    coreOrigins: [
      {
        title: '核心原点 ①：最有权 → 权势、领导与核心掌控',
        logic: '符：本义是古代朝廷传达命令或征调兵将的凭证。值符二字组合，象征 "执掌凭证之人" 或 "持有兵符的统帅"。',
        subItems: [
          { label: '概念', content: '重点的、有影响力的、服众的、威严的、德高望重的、有组织能力的。' },
          { label: '人物', content: '领袖、领导、管理者、负责人、老板。' },
          { label: '人体', content: '头（身体的最高决策与指挥中心）、手（掌控与执行权）。' },
          { label: '静物', content: '国旗、帽徽、领徽、委任状、证书、印章、玉玺、符。' },
          { label: '地理', content: '首都、首府、中央地带。' },
          { label: '性情', content: '气概雄伟、文韬武略、态度安然（领导者所具备的沉稳与魄力）。' },
        ],
      },
      {
        title: '核心原点 ②：最有名 → 声望、名誉与社会地位',
        logic: '《遁甲符应经》载："值符者，天乙之贵神，统摄八极"。《奇门法窍》云："值符天乙之神"，是八神之首。直符是最吉神。',
        subItems: [
          { label: '概念', content: '名牌的、高尚的（这些特质常与名声和地位相伴）。' },
          { label: '人物', content: '名人、明星、教授、宗教领袖（社会上广为人知并受尊敬的人物）。' },
          { label: '人体', content: '面（代表一个人的形象和尊严）。' },
          { label: '性情', content: '品质高雅、庄严矍铄。' },
          { label: '色彩', content: '绚烂、五彩缤纷（引人注目，与名气带来的光环效应相关）。' },
        ],
      },
      {
        title: '核心原点 ③：最有钱 → 财富、价值与稀有珍藏',
        logic: '直符代表高贵，引申为昂贵和稀有。',
        subItems: [
          { label: '概念', content: '高贵的、高档的、稀有的。' },
          { label: '动物', content: '名贵稀有的动物（如藏獒、老虎、熊猫、狮子、天鹅、金龙鱼、燕鱼）。' },
          { label: '植物', content: '名贵稀有的树种和花木（如金丝楠木、红木、君子兰、玫瑰花）。' },
          { label: '静物', content: '贵重高档物品、钱币、珠宝首饰、名贵古董、钻石、名人字画、名贵艺术品、高档家具（一切具有极高价值的物质财富）。' },
          { label: '地理', content: '庙宇（高贵）、高档场所、首饰店、古董行（交易贵重物品的场所）、金矿、珠宝、煤矿、油矿、古建筑。' },
        ],
      },
    ],
  },
  {
    id: 'god-tengshe',
    char: '蛇',
    pinyin: 'Téng Shé',
    summary: '腾蛇：变',
    tags: ['变幻', '缠绕', '惊恐'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002212306.png',
    story: '这是一个光怪陆离、充满虚假不实的夜晚。房间里充满了诡异的幻影和令人惊恐的火光（火）。人们发现自己陷入了复杂难解的缠绕和牵扯之中，如同被一条腾蛇紧紧捆住，身体感到惊恐和不安。他们所见所闻都怪异且难以捉摸，一切都显得弯曲和多变，充满了虚妄和变故。',
    coreOrigins: [
      {
        title: '核心原点 ①：变化 → 惊恐、虚幻与反复无常',
        logic: '腾蛇五行属火，其性虚幻多变。',
        subItems: [
          { label: '概念', content: '惊恐、虚惊、怪异、虚幻、梦境、变来变去、反反复复、虚诈、虚伪、华而不实、闪烁不定、光怪陆离、灯红酒绿、耀眼、妖艳、猜疑、变化、拐弯抹角。事情走势起伏不定、说好了又有变化。' },
          { label: '人物', content: '委屈婉转、善变之人、虚诈之人、变化无常之人、漂亮妖艳之人、做梦人、精神病患者（心智或行为不稳定）。' },
          { label: '性情', content: '虚伪巧诈、惊恐不安、心口不一（言行不一）。' },
          { label: '人体', content: '梦、精神（与虚幻、心智相关）。' },
          { label: '静物', content: '灯、霓虹灯、烟火（闪烁、耀眼、光怪陆离）、带花纹的布和衣服（花纹变化多端，或有迷惑性）。' },
          { label: '地理', content: '反光的建筑物、耀眼的光（视觉上的变幻）。' },
          { label: '天时', content: '太阳、星星（闪烁、光芒）。' },
        ],
      },
      {
        title: '核心原点 ②：缠绕 → 纠缠、弯曲与连接',
        logic: '源于蛇的形态，弯曲缠绕。',
        subItems: [
          { label: '概念', content: '缠绕、纠缠。（克直符，领导最怕人缠着）' },
          { label: '形态', content: '水蛇腰、驼背（弯曲的体态）。' },
          { label: '人体', content: '血管、神经、经络（身体内弯曲、连接的通道）。' },
          { label: '动物', content: '蛇、蟒、蚯蚓、爬虫类、海参、海肠、地蚕、蜈蚣（长条形、爬行或蠕动的动物）。' },
          { label: '植物', content: '龙抓槐、爬山虎、西瓜秧、南瓜秧、黄瓜秧、豆角秧、牵牛、红薯秧、藤萝、紫藤等一切蔓状类植物（缠绕、攀爬的植物）。' },
          { label: '静物', content: '绳子、绳索、锁链、渔网（缠绕、束缚）、烟囱、汽车排气筒（细长、弯曲）、腰带、鞋带、领带、项链、手链、表链、拉锁、发辫（细长、缠绕或连接的物品）。' },
          { label: '地理', content: '弯路、海岸线、河流、山脉、弯曲的建筑物（地理上的弯曲与连接）。' },
        ],
      },
      {
        title: '核心原点 ③：狠毒 → 狡猾与恶意',
        logic: '源于毒蛇的属性。',
        subItems: [
          { label: '概念', content: '狠毒。' },
          { label: '人物', content: '狡猾之人、口舌毒辣之人、呻吟之人、疑心之人（具有负面心性或表现出痛苦、不安的人）。' },
          { label: '性情', content: '奸佞心毒。' },
          { label: '人体', content: '心脏、血液（可引申为心惊肉跳、血液中毒或情绪剧烈波动）。' },
          { label: '地理', content: '窑燥（环境燥热、令人不安）。' },
        ],
      },
    ],
  },
  {
    id: 'god-taiyin',
    char: '阴',
    pinyin: 'Tài Yīn',
    summary: '太阴：密',
    tags: ['护佑', '细密', '阴私', '阴谋'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002212712.png',
    story: '一位心思细密的策划师，正坐在一间潮湿阴暗的佛寺地下室（阴私与护佑的交汇点）。他用精雕琢的笔迹，在一份复杂的策划案上标注着每一个细节，这份计划的核心是一场针对他人的密谋与欺诈（阴谋）。他的目标是实现升官与喜庆（护佑）。巨大的心理压力让他忍不住偷偷哭泣，涕液滑落，但他随即收敛心神，面向墙壁，像一个祷告者一样，低声祈求神灵的护佑，希望他的阴私行为能够得到庇佑，最终取得贞详（正直与顺利）的结果。',
    coreOrigins: [
      {
        title: '核心原点 ①：护佑 → 嘉奖、喜庆与精神庇护',
        logic: '太阴作为月神，为印绶，《奇门法窍》称其为 "阴祐之神"。',
        subItems: [
          { label: '概念', content: '护佑、贞详、喜庆、升官。' },
          { label: '人物', content: '歌手（喜庆、艺术）、祷告者（寻求或提供庇护/祝福）、助人为乐者。' },
          { label: '性情', content: '品质优良、正直慷慨、深谋远虑。' },
          { label: '静物', content: '金银、羽毛、喜庆用品、玩具、镜子。' },
          { label: '地理', content: '佛寺（精神庇护之地）。' },
        ],
      },
      {
        title: '核心原点 ②：细密 → 精雕琢与缜密策划',
        logic: '太阴作为阴柔之气，引申为一切需要精细、缜密、巧用心思的技艺与谋划。',
        subItems: [
          { label: '概念', content: '缜密、策划、雕刻、书写、复杂花纹。' },
          { label: '人物', content: '雕刻师、裁缝、策划师、书画家、秘书、文人（皆为心思缜密、依靠细腻技艺之人）。' },
          { label: '静物', content: '雕琢品、字迹、墨迹、字画、化妆品（需精细涂抹）、车（内部结构精密复杂）、碾碎机（将物体变细密）、镜子。' },
        ],
      },
      {
        title: '核心原点 ③：阴私 → 隐藏、遮盖与私密之地',
        logic: '太阴作为月亮，引申为一切隐蔽、暗藏、私密的人事物，多与女性和夜晚相关。',
        subItems: [
          { label: '概念', content: '隐避、藏匿、隐私、私通、遮盖、暗处。' },
          { label: '人物', content: '女友、二奶、私通者、女人、少女、暗中行事者、隐居者。' },
          { label: '形态', content: '脸色白净、口似樱桃、鼻子挺直、身白如玉、四指如葱（多形容女性或文人阴柔、细腻之美）。' },
          { label: '人体', content: '嘴（可说私密话）、肺（藏于胸腔）、皮肤（身体的遮盖）、私处、胎儿（藏于母腹）。' },
          { label: '地理', content: '山的阴面、看不见光的房屋、地下室、潮湿的地方、洞穴、厕所、洗手间（阴暗、私密或潮湿之地）。' },
        ],
      },
      {
        title: '核心原点 ④：阴谋 → 诅咒、欺诈与暗中伤害',
        logic: '这是“阴私”的负面延伸，代表利用隐秘达成的负面策划，如诡计、口舌是非与精神攻击。',
        subItems: [
          { label: '概念', content: '密谋、诅咒、阴谋诡计、哭泣、忧疑、欺诈、口舌、淫乱。' },
          { label: '人物', content: '巫师、哭泣者。' },
          { label: '性情', content: '阴匿暗昧。' },
          { label: '人体', content: '涕液（哭泣、忧伤的产物）。' },
          { label: '动物', content: '刺猬、老鼠、猫、猫头鹰（夜间出没、行动隐秘的动物）。' },
          { label: '静物', content: '冰、冷饮（“阴”冷之物）。' },
        ],
      },
    ],
  },
  {
    id: 'god-liuhe',
    char: '合',
    pinyin: 'Liù Hé',
    summary: '六合：多',
    tags: ['多', '合作', '和气', '盒子'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002212844.png',
    story: '在一条热闹非凡的婚礼（婚姻）现场，媒人（中介）正在为两大家族的合作进行调解。现场人头攒动（多人），气氛融洽和睦（和谐），所有人都像被一个大盒子（容器）装在一起，形成一个稳定的集体。新娘将信物放入一个精致的盒子中，象征着两人的结合和永久的契约。这个场景充满了中介、和解与社会关系。',
    coreOrigins: [
      {
        title: '核心原点 ①：多 → 众多、聚集与群体',
        logic: '六合指上下和四方，代表多/古代六就是多，是虚指。',
        subItems: [
          { label: '概念', content: '众多、聚集、重叠。' },
          { label: '人体', content: '手、手指、脚趾、毛发、眉毛（皆为复数、成簇存在的身体部分）。' },
          { label: '动物', content: '兔子、鸳鸯、狼、麻雀、蜻蜓、蝴蝶、蜜蜂、蝗虫、燕子、大雁、天鹅（一切群居双聚的动物）。' },
          { label: '植物', content: '小树、花草、果树、竹林、柳树（常常是成片、成林生长）。' },
          { label: '地理', content: '草地、公园、竹林、苇塘、葱岭、树林（众多植物的聚集地）。' },
          { label: '色彩', content: '多种颜色的组合。' },
        ],
      },
      {
        title: '核心原点 ②：合作 → 联合、交易与婚姻',
        logic: '“合”的本义就是聚合与匹配。',
        subItems: [
          { label: '概念', content: '合作、联合（强强联合）、交易、谈判、结婚、共同、适合、相聚、联合、吻合、适合、共同。' },
          { label: '人物', content: '中介人（促成合作）、组织能力强的人（能聚集众人）、艺人（需要团队合作）。' },
          { label: '静物', content: '结婚证书、合约、合同、证书、信印、书契。' },
        ],
      },
      {
        title: '核心原点 ③：和气 → 仁慈、祥和与包容',
        logic: '由“合作”的良好结果引申，代表一种欢乐、平和、与人为善的氛围与品格。',
        subItems: [
          { label: '概念', content: '欢乐、祥和、仁慈、包容、平和。' },
          { label: '人物', content: '乐善好施之人、医生（带来平和安康）、人缘好的人、教师、僧道、基督徒、信教人、儿童、幼儿（角色本身多代表祥和、仁慈或天真）。' },
          { label: '形态', content: '圆脸、兔牙、一团和气、笑容可掬、点头哈腰、缩头耸肩（皆为谦和、不具攻击性的姿态）、长相年轻。' },
          { label: '性情', content: '开朗和平、仁慈谦让、荐贤不妒、喜做说合之事。' },
          { label: '方位/天时/色彩', content: '东方；风和、旭日、春天、早晨；绿色。' },
          { label: '其他', content: '人群聚集、社交活动（与和气、包容相关的群体现象）。' },
        ],
      },
      {
        title: '核心原点 ④：盒子 → 收拢、关闭与容器',
        logic: '这是“聚合”的物理形态隐喻，代表一切具有收纳、包裹、容纳功能的事物，如同一个“盒子”。',
        subItems: [
          { label: '概念', content: '收拢、关闭、合抱。' },
          { label: '静物', content: '合子、伞、低矮的柜子、箱子、椅子、床、窗（框状结构，有开合之能）、果品（常被装在盒/篮里）、羽毛、布帛、衣囊（用于包裹、容纳）、轿车、轮船、飞机（容纳人或物的移动容器）、钱财（常被收纳在容器里）。' },
        ],
      },
    ],
  },
  {
    id: 'god-baihu',
    char: '虎',
    pinyin: 'Bái Hǔ',
    summary: '白虎：凶',
    tags: ['凶', '斗争', '技术'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002213057.png',
    story: '在一条宽阔的道路上，一队威猛的士兵（军人）正在进行激烈的战斗。现场充满了血光之灾和刀枪，有人因冲突而受了重伤，痛苦地倒在地上。这股强悍的力量和肃杀之气，如同白虎下山般，代表着武力和煞气。这个场景的核心是刚猛、灾祸和伤病。',
    coreOrigins: [
      {
        title: '核心原点 ①：凶 → 斗争、伤灾与死亡',
        logic: '由“虎”的凶猛本性引申，代表一切具有攻击性、破坏性、导致斗争与伤亡的人事物。',
        subItems: [
          { label: '概念', content: '凶猛、威严、斗争、刚毅、冷酷、强硬、官司、伤灾、牢狱、疾病、死亡。' },
          { label: '人物', content: '好斗之人、黑社会之人、罪犯、重病人、凶杀人、孝服人、恐怖人、死亡者、屠夫。' },
          { label: '性情', content: '凶猛刚毅、大义凛然、残暴易怒、决断冲突。' },
          { label: '人体', content: '骨骼（身体最坚硬的部分）、拳头。' },
          { label: '动物', content: '虎、豹、豺、狼、猎狗、鹰、食肉动物。' },
          { label: '植物', content: '猪笼草、蒺藜草、蝎子草、荆棘、枣树、杜梨树、刺槐（一切带刺或能致伤的植物）。' },
          { label: '静物', content: '毒品、刀剑、枪枝、武器、凶器。' },
          { label: '天时', content: '闪电、霹雳、狂风、龙卷风、飓风、地震、火山喷发。' },
        ],
      },
      {
        title: '核心原点 ②：阻隔 → 道路、关卡与屏障',
        logic: '白虎金神，主道路、阻隔。',
        subItems: [
          { label: '概念', content: '阻隔、道路。' },
          { label: '地理', content: '道路、关卡、收费站、悬崖、峭壁、房角、堤坝、闸口、路口。' },
          { label: '静物', content: '锁、碾子、磨、石狮子（常立于门口形成关卡）、瓦、石、网罗、交通信号灯（道路上的规则性阻隔）。' },
        ],
      },
      {
        title: '核心原点 ③：技艺 → 权力、技术与刚强',
        logic: '白虎也代表技术过硬，尤其是武职或刚性技术。',
        subItems: [
          { label: '概念', content: '权力、严肃、艳丽（极致的威严和力量感）、技术过硬。' },
          { label: '人物', content: '技术过硬之人、威猛之人、权力之人、讲义气之人（依靠刚毅的原则行事）、高科技人员、公安、军警、捕盗人、侍卫、军人、工匠。' },
          { label: '形态', content: '圆眼、虎头虎脑、面部表情严肃或死板、身体多肌肉、强健。' },
          { label: '人体', content: '肺、大肠（五行属金）。' },
          { label: '静物', content: '金银、石制品、铁质品、钛制品（坚硬、需技术加工的材料）。' },
        ],
      },
    ],
  },
  {
    id: 'god-xuanwu',
    char: '武',
    pinyin: 'Xuán Wǔ',
    summary: '玄武：骗',
    tags: ['欺骗', '水性', '玄虚'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002213237.png',
    story: '夜色漆黑，一名小偷（玄武）正试图从水边的房屋中偷偷溜走（逃跑）。他使用欺骗的手段，隐藏了自己的行踪，试图盗窃财物。他的行为充满了不正当和不道德的色彩，如同一团黑色的迷雾，在暗中行事。这个场景充满了偷盗、虚假和潜逃。',
    coreOrigins: [
      {
        title: '核心原点 ①：欺骗 → 智慧、谎言与诡计',
        logic: '由“玄”的不可捉摸引申为智慧的两面性：正面是“智巧”，负面是“诡诈”。',
        subItems: [
          { label: '概念', content: '领悟、理解、智慧、偷盗、偷情、谎言、阴谋、诡计。' },
          { label: '人物', content: '聪明多智者、能言善辩者、文艺人才、诚信不高者、爱说谎话者、虚伪不实者、巧辩反复者、小偷、导演、演员、盗贼、娼妇。' },
          { label: '形态', content: '贼眉鼠眼、神色不定、弯腰驼背。' },
          { label: '性情', content: '机智灵活、巧言善辩、干练虚伪、偷奸取巧。' },
          { label: '动物', content: '老鼠、鹰、蛇、猫头鹰（被赋予机警、狡猾或神秘的文化形象）。' },
          { label: '植物', content: '水草、海带、紫菜、蔬菜、水果、含水量大的植物。' },
          { label: '静物', content: '盐、酱、醋、油、酒、油漆、伞、碳、一切流体类物质；瓶、罐、瓢、缸等容器。' },
          { label: '地理', content: '阴沟、地井、下水道、地窖、地下室、低洼地、河流、池塘、湖泊、污水、粪便、厕所、洗手间、厨房。' },
        ],
      },
      {
        title: '核心原点 ②：玄虚 → 深奥、幻想与眩晕',
        logic: '这是“玄”的本意，代表一切幽深、神秘、模糊不清、令人困惑的事物。',
        subItems: [
          { label: '概念', content: '深奥、玄虚、眩晕、不可靠、不可捉摸、玄妙、神秘、幻想、神秘学、心理学、宗教、法术。' },
          { label: '人物', content: '文士、醉客、孕妇、胎儿。' },
          { label: '形态', content: '肩窄腿细、视力衰退。' },
          { label: '静物', content: '图片、图画、文章、印信（承载着抽象信息，其内涵玄妙）。' },
          { label: '地理', content: '不见光的场所、牢狱。' },
          { label: '天时', content: '阴天、黑天。' },
          { label: '色彩', content: '黑色、玄色。' },
        ],
      },
      {
        title: '核心原点 ③：水性 → 液体、阴暗与滋润',
        logic: '此逻辑源于其五行“水”的根本属性，代表一切与水、液体、阴湿环境相关的人事物。',
        subItems: [
          { label: '人物', content: '水产经营者。' },
          { label: '人体', content: '眼睛、头发（皆属肾水所主）、肾、膀胱、尿液、体液。' },
          { label: '动物', content: '鱼类、喜水动物。' },
          { label: '植物', content: '水草、海带、紫菜、蔬菜、水果、含水量大的植物。' },
          { label: '静物', content: '盐、酱、醋、油、酒、油漆、伞、碳、一切流体类物质；瓶、罐、瓢、缸等容器。' },
          { label: '地理', content: '阴沟、地井、下水道、地窖、地下室、低洼地、河流、池塘、湖泊、污水、粪便、厕所、洗手间、厨房。' },
        ],
      },
    ],
  },
  {
    id: 'god-jiudi',
    char: '地',
    pinyin: 'Jiǔ Dì',
    summary: '九地：稳',
    tags: ['稳定', '吝啬'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002213409.png',
    story: '在广袤的土地（大地）上，一位农民正在进行长期的耕作（农业）。他为人沉稳保守，所有行动都缓慢而扎实。他的财富被深深埋藏在地下（隐藏），追求的是持久的和安定的生活。这里的一切都处于静止状态，需要时间来酝酿，象征着低调、迟缓和扎根。',
    coreOrigins: [
      {
        title: '核心原点 ①：稳定 → 厚重、包容与持久',
        logic: '九地指地的最深处或九种不同的土地类型，代表坚固与长久。',
        subItems: [
          { label: '概念', content: '稳定、厚重、柔顺、文静、恭敬、谦卑、博大、包容、关怀。' },
          { label: '人物', content: '乡农、医生、老妇人、道姑、村姑、性格柔顺的人。' },
          { label: '形态', content: '大腹、肥厚、方脸多肉、肥胖、身材五短、声音如瓮。' },
          { label: '性情', content: '柔顺文静。' },
          { label: '人体', content: '胃、脾、肉、鼻、唇、腹、臀。' },
          { label: '动物', content: '牛、猪、熊猫、大象等动作缓慢、性情温柔的动物。' },
          { label: '植物', content: '地瓜、土豆、农作物、地衣、苔藓、地丁、姜、荸荠、大蒜、中草药。' },
          { label: '静物', content: '五谷、布帛、沙石、缸、瓦盆、瓦罐、土制品、载物载人的车子。' },
          { label: '地理', content: '地基、低洼地带、地下水。' },
          { label: '天时', content: '多云、阴天（天气变化不大，相对稳定）。' },
        ],
      },
      {
        title: '核心原点 ②：消极与吝啬 → 固守、缓慢与潜藏',
        logic: '这是由“稳定”过度而产生的共同负面状态。过度的静止不动导致了缺乏进取心的消极、发展缓慢，并倾向于对内固守（吝啬）和对外潜藏。',
        subItems: [
          { label: '概念', content: '矮小、消极、哭泣、模糊、缓慢、困惑、吝啬、自私、旧物。' },
          { label: '人物', content: '狱警（工作于压抑环境）、地下工作者、不公开的职业、慢吞吞的人、吝啬之人、自私消极的人。' },
          { label: '性情', content: '自私消极、缺乏上进心、吝啬节俭。' },
          { label: '动物', content: '地蚕、虫类（行动缓慢，生活于地下）。' },
          { label: '静物', content: '储存粮食的器皿、储存衣物的柜子、首饰盒（核心意象为“藏”和“存”）。' },
          { label: '地理', content: '地窖、地下室、地道、地下铁、地摊、地炉、地炕（一切与地下、潜藏相关的场所）。' },
        ],
      },
    ],
  },
  {
    id: 'god-jiutian',
    char: '天',
    pinyin: 'Jiǔ Tiān',
    summary: '九天：高',
    tags: ['高', '权威', '乾元'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251002213445.png',
    story: '一位拥有远大抱负的旅行者（九天）站在高耸的山峰上，俯瞰着广阔的天空（高处）。他正计划着一次快速的远行（运动、旅行），心中充满了开放和进取的精神。他追求的是显赫的地位和飞黄腾达的未来，象征着一切向上、外露和快速变化的事物。',
    coreOrigins: [
      {
        title: '核心原点 ①：高 → 高远、开阔与动态',
        logic: '源于“天”最直观的物理特征——高。由此引申出一切与高处、开阔、远大、以及天空中的动态相关的事物。',
        subItems: [
          { label: '概念', content: '高大、天空、虚无、高处、极端、豪放。' },
          { label: '形态', content: '高大、魁梧。' },
          { label: '人体', content: '头、额头（人体的最高处）。' },
          { label: '动物', content: '飞鸟、天鹅（高空飞行的动物）。' },
          { label: '植物', content: '高大的树、高粱、高山或高原植物。' },
          { label: '静物', content: '高耸、帽子、眼镜、天马、直升飞机。' },
          { label: '地理', content: '天井、天车、开阔地、高原、高空、高大建筑、楼房最高层。' },
          { label: '天时', content: '蓝天、雷电（天空的景象）、秋天（天高气爽）。' },
        ],
      },
      {
        title: '核心原点 ②：贵 → 珍贵、美丽与光明',
        logic: '源于“天”的引申价值。天空给予光明，孕育珍宝，因此“九天”也代表一切贵重、美好、光明、有极高价值的事物。',
        subItems: [
          { label: '概念', content: '光明、恩赐、幸福、美丽。' },
          { label: '动物', content: '龙（神话中最高贵的神兽）。' },
          { label: '静物', content: '金玉、宝石、钱、镜子、铜铁、水果（自然的珍贵馈赠）、光亮玲珑物。' },
          { label: '地理', content: '豪华地方。' },
          { label: '色彩', content: '白色、青色（纯净、高贵的颜色）。' },
        ],
      },
      {
        title: '核心原点 ③：乾 (Qián) → 权威、主宰与意志',
        logic: '九天的核心卦象“乾”，代表天、君王、父亲。它象征着至高无上的权威、领导力，以及远大的意志和理想。',
        subItems: [
          { label: '概念', content: '重要、主宰、意志、灵魂、聪明。' },
          { label: '人物', content: '领导、首脑、长辈、父辈、长官、僧道、神甫、牧师、有威望之人。' },
          { label: '形态', content: '威严、脸方正、手绵软、言语掷地有声。' },
          { label: '性情', content: '不怒而威、高强好动、志向远大、有时好高骛远、不切实际。' },
          { label: '动物', content: '马（龙马精神）、虎、狮（百兽之王，权威象征）。' },
          { label: '静物', content: '剑戟、刀枪（权力的工具）。' },
          { label: '地理', content: '首府、办公室、经理室（权力的场所）。' },
        ],
      },
    ],
  },
];
